$(document).ready(()=> {
    $(".trigger-secondary").click(function() {
        $(this).hasClass("secondary-open")?$(this).removeClass("secondary-open"): $(this).addClass("secondary-open")
    }
    ), $(".mobile-menu-toggle").click(()=> {
        $(".mobile-menu-container").addClass("open"), $(".mobile-menu").addClass("open"), $("html").css("overflow", "hidden"), $("body").css("overflow", "hidden")
    }
    ), $(".mobile-menu .close-menu, .mobile-whitespace").click(()=> {
        $(".mobile-menu").removeClass("open"), $(".mobile-menu-container").removeClass("open"), $("html").css("overflow", ""), $("body").css("overflow", "")
    }
    )
});